import "core-js/modules/es.object.to-string.js";
import { updateBasicInfo } from '@/services/systemsetting';
export default {
  name: 'basicSetting',
  components: {},
  i18n: require('./../i18n-basucSettings'),
  props: ['systemSetting'],
  watch: {
    systemSetting: function systemSetting() {
      var self = this;
      self.systemSettingData = self.systemSetting;
      self.initData();
    }
  },
  computed: {
    uploadLimit: function uploadLimit() {
      return localStorage.uploadLimit;
    }
  },
  data: function data() {
    return {
      currencySymbol: 1,
      currencySymbolList: [{
        id: 1,
        name: '日元'
      }, {
        id: 2,
        name: '美元'
      }, {
        id: 3,
        name: '人民币'
      }],
      systemSettingData: this.systemSetting,
      loadingSave: false,
      loadingLogo: false,
      loadingIcon: false,
      action: "",
      updateData: {},
      rules: {
        storeName: [{
          required: true,
          message: this.$t('basicSettings.pleaseinputShopName'),
          trigger: 'blur'
        }]
      },
      dataForm: {
        id: '',
        storeName: '',
        leftCurrencySymbol: '',
        rightCurrencySymbol: '',
        storeLogo: '',
        storeIcon: '',
        lastUpdateTime: '',
        operateType: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.action = process.env.VUE_APP_API_BASE_URL + "/common/upload/";
    self.updateData = {
      type: 6
    };
    self.initData();
  },
  methods: {
    initData: function initData() {
      var self = this;
      //初始化页面数据
      if (self.systemSettingData.leftCurrencySymbol && self.systemSettingData.leftCurrencySymbol == '$') {
        self.currencySymbol = 2;
      } else if (self.systemSettingData.rightCurrencySymbol && self.systemSettingData.leftCurrencySymbol == '元') {
        self.currencySymbol = 3;
      } else if (self.systemSettingData.rightCurrencySymbol && self.systemSettingData.leftCurrencySymbol == '円') {
        self.currencySymbol = 1;
      }
      self.dataForm = {
        id: self.systemSettingData.id,
        storeName: self.systemSettingData.storeName,
        leftCurrencySymbol: self.systemSettingData.leftCurrencySymbol,
        rightCurrencySymbol: self.systemSettingData.rightCurrencySymbol,
        storeLogo: self.systemSettingData.storeLogo,
        storeIcon: self.systemSettingData.storeIcon,
        lastUpdateTime: self.systemSettingData.lastUpdateTime,
        operateType: self.systemSettingData.operateType
      };
    },
    handleChangeLogo: function handleChangeLogo(info) {
      if (info.file.status === 'uploading') {
        this.loadingLogo = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          this.dataForm.storeLogo = info.file.response.data.uploadfilepath;
          this.loadingLogo = false;
        }
      }
    },
    handleChangeIcon: function handleChangeIcon(info) {
      if (info.file.status === 'uploading') {
        this.loadingIcon = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          this.dataForm.storeIcon = info.file.response.data.uploadfilepath;
          this.loadingIcon = false;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt2M = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt2M;
    },
    /* 保存 */save: function save() {
      var _this = this;
      var self = this;
      var leftCurrencySymbol = "";
      var rightCurrencySymbol = "";
      if (self.currencySymbol == 1) {
        rightCurrencySymbol = "円";
      } else if (self.currencySymbol == 2) {
        leftCurrencySymbol = "$";
      } else if (self.currencySymbol == 3) {
        rightCurrencySymbol = "元";
      }
      console.log(self.currencySymbol);
      var param = {
        id: self.dataForm.id,
        storeName: self.dataForm.storeName,
        leftCurrencySymbol: leftCurrencySymbol,
        rightCurrencySymbol: rightCurrencySymbol,
        storeLogo: self.dataForm.storeLogo,
        storeIcon: self.dataForm.storeIcon,
        lastUpdateTime: self.dataForm.lastUpdateTime,
        operateType: self.dataForm.operateType
      };
      console.log(param);
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          self.loadingSave = true;
          updateBasicInfo(param).then(function (result) {
            if (result.data.code == 200) {
              //更新成功后更新 最后更新时间
              localStorage.setItem("leftCurrencySymbol", leftCurrencySymbol);
              localStorage.setItem("rightCurrencySymbol", rightCurrencySymbol);
              self.$emit('update');
              _this.$message.success(_this.$t('public.saveSuccessfully'));
            }
            self.loadingSave = false;
          }).finally(function () {
            self.loadingSave = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};